import { render, staticRenderFns } from "./pandaCoinRecord.vue?vue&type=template&id=4973ec9e&scoped=true"
import script from "./pandaCoinRecord.vue?vue&type=script&lang=ts"
export * from "./pandaCoinRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973ec9e",
  null
  
)

export default component.exports